import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Componente que redirige automáticamente a la página de perfil directa
 */
const ProfileRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirigir a la página de perfil directa
    navigate('/direct-profile', { replace: true });
  }, [navigate]);

  // Mostrar un mensaje de carga mientras se redirige
  return (
    <div className="container" style={{ padding: '50px 0', textAlign: 'center' }}>
      <h2>Redirigiendo...</h2>
      <p>Por favor espere un momento.</p>
    </div>
  );
};

export default ProfileRedirect;
